import { render, staticRenderFns } from "./CourseInfo.vue?vue&type=template&id=23e602f0&scoped=true&"
import script from "./CourseInfo.vue?vue&type=script&lang=js&"
export * from "./CourseInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23e602f0",
  null
  
)

export default component.exports